import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface Partner {
  id: string;
  slug: string;
  branding_title: string;
  legal_name: string;
  legal_id: string | null;
  contact_email: string | null;
  destination_url: string | null;
  is_active: boolean;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export function usePartners() {
  const query = useQuery({
    queryKey: ["partners"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("partners")
        .select("*")
        .order("branding_title");
      if (error) throw error;
      return (data as Partner[]) ?? [];
    },
  });

  return {
    data: query.data,
    partners: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
